import { BookOpen, Briefcase, FileText, LayoutDashboard, Mail, Settings } from 'lucide-react';
import React, { Fragment, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Sidebar from '../component/admin/dashboard/Sidebar';
import { AdminHeader } from '../component/admin/dashboard/AdminHeader';

const AdminLayout = () => {
  const [activePage, setActivePage] = useState('dashboard');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true );
  const [menuItems, setMenuItems] = useState([
    {
      id: "dashboard",
      label: "Dashboard",
      icon: LayoutDashboard,
      path: "/dashboard",
    },
    { id: 'meta-details', label: 'All Pages Meta Details', icon: FileText, path: "/mata-pages", },
    {
      id: "blogs",
      label: "Blogs",
      icon: BookOpen,
      path: "/blogs",
    },
    { id: 'portfolios', label: 'Portfolios', icon: Briefcase, path: "/portfolios" },
    { id: 'enquiries', label: 'Enquiries', icon: Mail , path: "/enquiries" },
  ]
  )
  return (
    <Fragment>
      <div className="flex h-screen bg-gray-50">

        {/* Sidebar */}
        {/* <aside className="w-60 bg-white shadow-md flex flex-col p-6">
          <div className="mb-8">
            <img src="/images/MetaFox.png" alt="logo" className="w-35 h-auto mx-auto" />
          </div>
          <nav className="flex-1">
            <ul className="space-y-2">
              <li>
                <Link
                  to="/admin/dashboard"
                  className="block px-2 py-2 rounded hover:bg-gray-200 flex gap-2 transition-colors duration-200 font-medium"
                >
                  <LayoutDashboard className='w-6 h-6'/>
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/users"
                  className="block px-2 py-2 rounded hover:bg-gray-200 flex gap-2 transition-colors duration-200 font-medium"
                >
                  <Users className='w-6 h-6'/>
                  Users
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/settings"
                  className="block px-2 py-2 rounded hover:bg-gray-200 flex gap-2 transition-colors duration-200 font-medium"
                >
                  <Settings className='w-6 h-6'/>
                  Settings
                </Link>
              </li>
            </ul>
          </nav>
        </aside> */}

        <Sidebar
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
          menuItems={menuItems}
          activePage={activePage}
          setActivePage={setActivePage}
        />

        {/* Main Content */}
        <main className="flex-1 flex flex-col overflow-hidden">
          <AdminHeader pageTitle={'Dashboard'} onMenuClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
          <div className="flex-1 p-6 overflow-y-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </Fragment>
  );
};

export default AdminLayout;
